<template>
    <div class="scroll-y">

        <!--<navigator-->
        <!--:avaliableReports="avaliableReports"-->
        <!--:dateFrom="dateFrom"-->
        <!--:dateTo="dateTo">-->
        <!--</navigator>-->
        <div class="container-fluid py-2 align-items-center my-2">
          <div class="row">
            <div class="col-md-3">
              <span class="darker fs-larger font-weight-600">Agent Sales Report:</span>
            </div>
            <div class="col-md-9">
              <div class="row justify-content-end">
                <div class="col-sm-6 d-flex flex-row align-items-center">
                  <label class="mr-2 darker">Departure Date:</label>
                  <v-select :options="dateOptions" :onChange="changeTimeOption" v-model="selectedDateOption" ></v-select>
                </div>

                <template v-if="showDatePickers">
                  <date-range
                    :from="dateFromObj"
                    :to="dateToObj"
                    @setFrom="setCustomDateFrom"
                    @setTo="setCustomDateTo"
                  ></date-range>
                </template>
              </div>
            </div>
          </div>
        </div>

        <div class="container-fluid py-2 align-items-center my-2">
          <div class="row">
            <div class="col-md-12 d-flex justify-content-end">
              <button class="btn tertiary" @click="toggleShowGraph">{{showCartMessage}}</button>
            </div>
          </div>
        </div>

        <div class="container-fluid">
          <div class="row" v-if="showGraph">
              <div class="col-md-12">
                  <graph class="graph py-3" :height="300" :chartData="graphData" ></graph>
              </div>
          </div>
        </div>

        <div class="container-fluid bg-lightest pt-3 pb-4">
            <div class="row">

                <!-- **** FILTERS **** -->
                <div class="col-md-8">
                  <div class="row">
                    <div class="col-md-4 d-flex flex-row align-items-center">
                        <v-select :options="agentsOptions" :onChange="changeAgentsOption" v-model="selectedAgentsOption" ></v-select>
                    </div>
                    <div class="col-md-4 d-flex flex-row align-items-center">
                      <v-select :options="productsOptions" :onChange="changeProductsOption" v-model="selectedProductsOption" ></v-select>
                    </div>
                    <div class="col-md-4 d-flex flex-row align-items-center">
                      <v-select :options="statusOptions" :onChange="changeStatusOption" v-model="selectedStatusOption" ></v-select>
                    </div>

                  </div>
                </div>

                <div class="col-md-4 d-flex justify-content-end">

                  <span class="clickToOpen d-flex flex-row align-items-center mr-4 pointer">
                    <i class="ico-filter medium fs-larger" @click.stop="toggleColumnOptions"></i>
                    <span class="medium font-weight-600" @click.stop="toggleColumnOptions">Column</span>
                    <ul class="selectDrawer left" v-if="showColumnOptions" v-click-outside="toggleColumnOptions">
                      <li v-for="columnOption in columnOptions" class="px-2 py-1">
                        <checkbox v-model="columnOption.value">
                          {{columnOption.label}}
                        </checkbox>
                      </li>
                    </ul>
                  </span>

                  <span class="clickToOpen d-flex flex-row align-items-center pointer">
                    <i class="ico-export medium fs-larger" @click.stop="exportSales"></i>
                    <span class="medium font-weight-600" @click.stop="exportSales">Export</span>
                    <!--<i class="ico-export medium fs-larger" @click.stop="toggleExportOptions"></i>-->
                    <!--<span class="medium font-weight-600" @click.stop="toggleExportOptions">Export</span>-->
                    <!--<ul class="selectDrawer left" v-if="showExportOptions" v-click-outside="toggleExportOptions">-->
                      <!--<li v-for="exportOption in exportOptions" class="px-2 py-1 font-weight-600 fs-small dark">-->
                        <!--<checkbox>-->
                          <!--{{exportOption}}-->
                        <!--</checkbox>-->
                      <!--</li>-->
                    <!--</ul>-->
                  </span>

                </div>
            </div>

            <div class="row mt-2">
                <div class="col-sm-12" v-if="rowsLoaded">
                    <list
                    class="w-100"
                    :header="header"
                    :body="body"
                    :rows="filteredList"
                    :actions="actions"
                    ></list>
                </div>
                <div class="col-sm-12 d-flex justify-content-end my-4" v-if="pageInfo">
                    <uib-pagination v-model="pagination" :total-items="pageInfo.totalItemCount" :boundary-link-numbers="false" :max-size="7" @change="pageChanged"></uib-pagination>
                </div>
            </div>



            <div class="row my-4 pt-4">
                <div class="col-sm-12 text-right">
                    <router-link :to="{ name: 'reports'}">
                        <button type="button" class="btn add wide bg-dark">Return to dashboard</button>
                    </router-link>
                </div>
            </div>

        </div>


    </div>
</template>

<script>
    import extendedVSelect from '@/extends/vue-select'
    import List from '@/tools/list/baseList'
    import VueDatepicker from 'vuejs-datepicker'
    import graph from '@/tools/charts/reports/newReport'
    import Export from '@/tools/Export' //this is a copy from resertions
    import DateRange from '@/tools/DateRange'
    import { mapGetters, mapActions } from 'vuex'

    import Navigator from './Navigator'

    export default {
        data: function(){
            return {
                showGraph: true,
                showCartMessage: 'Hide Chart',
                dateOptions:[
                  {
                    label:'Custom',
                    value:'custom'
                  },
                  {
                    label:'Today',
                    value:'today'
                  },
                  {
                    label:'This Week',
                    value:'this-week'
                  },
                  {
                    label:'This Month',
                    value:'this-month'
                  },
                  {
                    label:'Last 3 Months',
                    value:'last-3-months'
                  },
                  {
                    label:'Last 12 Months',
                    value:'last-12-months'
                  }
                ],
                selectedDateOption:{
                  label:'Last 12 Months',
                  value:'last-12-months'
                },
                agentsOptions:[
                  {
                    label: 'All Agents',
                    value: undefined
                  }
                ],
                selectedAgentsOption: {
                  label: 'All Agents',
                  value: undefined
                },
                productsOptions:[
                  {
                    label: 'All Products',
                    value: undefined
                  }
                ],
                selectedProductsOption: {
                  label: 'All Products',
                  value: undefined
                },
                statusOptions:[
                  {
                    label: 'All Status',
                    value: undefined
                  },
                  {
                    label: 'In Due',
                    value: 0
                  },
                  {
                    label: 'Invoiced',
                    value: 1
                  },
                  {
                    label: 'Payed',
                    value: 2
                  },
                  {
                    label: 'NotPayed',
                    value: 3
                  },
                  {
                    label: 'canceled',
                    value: 100
                  }
                ],
                selectedStatusOption: {
                  label: 'All Status',
                  value: undefined
                },
                columnOptions:[
                  {
                    label:'Regular Agents',
                    value:'regular-agents',
                    visible: true,
                  },
                  {
                    label:'Staff Bookings',
                    value:'staff-bookings',
                    visible: true,
                  },
                  {
                    label:'Online Agents',
                    value:'online-agents',
                    visible: true,
                  },
                  {
                    label:'Website',
                    value:'website',
                    visible: true,
                  }
                ],
                exportOptions:[
                  'MS Excel',
                  'PDF',
                  'CVS',
                  'Email'
                ],
                showExportOptions: false,
                showColumnOptions: false,
                dateFrom:new Date(2017, 9, 1),
                dateTo:new Date(2017, 9, 31),
                showDatePickers: false,
                rows: [],
                rowsLoaded: false,
                header: {
                    selection: {
                        active: true,
                        event: function(event) {}
                    },
                    list: {
                        departureDate: 'Departure Date',
                        productName: 'Activity',
                        bookingTicket: 'Booking Ticket',
                        agentName: 'Agent',
                        resources: 'Resources',
                        commissionAmount: 'Comm Amount',
                        comissionValue: '%',
                        totalGrossprice: 'Total Price',
                        bookingPaymentStatus: 'Status'
                    },
                },
                body: {
                    selection: {
                        active: true,
                        event: function(event) {}
                    },
                    customRowEvent: this.sharedRowEvent,
                    customCells: {
                        departureDate: function(row) {
                            let result = '-';

                            if(row.departureDate){
                              const data = row.departureDate.split(' ');
                              result = '<div>' + data[0] + '</div><div class="sub">' + data[1] + '</div>';
                            }
                            return result;
                        },
                        resources: function (row) {
                            return '<span title="' + row.resources + '">' + row.resources + '</span>';
                        },
                        commissionAmount: function(row) {
                            return row.commissionAmount.toFixed(2).toString().replace('.', ',') + ' €';
                        },
                        totalGrossprice: function(row) {
                          return row.totalGrossprice.toFixed(2).toString().replace('.', ',') + ' €';
                        },
                        bookingPaymentStatus: function(row) {
                            let result = '';

                            if (row.bookingAgentPaymentStatus !== undefined || row.bookingAgentPaymentStatus !== null) {
                                if (row.bookingAgentPaymentStatus === 0) {
                                  result = '<p class="text-info bold">In Due</p>'
                                } else if (row.bookingAgentPaymentStatus === 1) {
                                  result = '<p class="text-secondary bold">Invoiced</p>'
                                } else if (row.bookingAgentPaymentStatus === 2) {
                                  result = '<p class="text-success bold">Payed</p>'
                                } else if (row.bookingAgentPaymentStatus === 3) {
                                  result = '<p class="text-warning bold">Not Payed</p>'
                                } else if (row.bookingAgentPaymentStatus === 100) {
                                  result = '<p class="text-danger bold">canceled</p>'
                                }
                            }
                            return result;
                        }
                    },
                },
                actions: {
                    label : 'Actions',
                    list: [],
                },
                // totalsHeader: {
                //     selection: {
                //         active: false,
                //         event: function(event) {}
                //     },
                //     list: {
                //         name : '',
                //         totalBrutoReservas : 'Total Bruto Reservas',
                //         totalBrutoComissoes : 'Total Bruto Comissões',
                //         totalLiquidoReservas : 'Total Liquido Reservas',
                //         totalExtras : 'Total Extras',
                //         totalComissoesExtras : 'Total Comissões Extras',
                //         totalLiquidoExtras : 'Total Liquido Extras',
                //         totalAReceber : 'Total A Receber',
                //         totalRecebido : 'Total Recebido',
                //         totalBrutoCancelados : 'Total Bruto Cancelados'
                //     },
                // },
                pageInfo: null,
                pagination: {
                    currentPage: 1,
                },
                allSales: [],
            }
        },
        mounted: function() {
            this.updateSales(true);
        },
        computed:{
            ...mapGetters([
              'account'
            ]),
            dateFromObj: function(){
              return moment(this.dateFrom)
            },
            dateToObj: function(){
              return moment(this.dateTo)
            },
            filteredList: function() {
              console.log('***FILTERED LIST***');

              var originalList = this.rows;
              var filteredList = originalList;

              console.log('originalList: ', originalList);
              console.log('filteredList: ', filteredList);
              // var filterArr = this.filters;
              // var filteredList = [];
              // var filterOk = Boolean;

              // let response = await this.loadSales(this.dateFrom, this.dateTo);

              // console.log(response);

              /*
              //FILTER simple proof of concept
              filteredList = originalList.filter(function(row){
                  filterOk = false;
                  for (var i = 0; i < filterArr.length; i++) {
                      //teste if the filter applies
                      filterOk = (String(row[filterArr[i]['type']]).toLowerCase().indexOf(String(filterArr[i]['value']).toLowerCase()) !== -1)
                  }
                  return filterOk;
              });


              if(filteredList.length < 1){
                  // if empty return all
                  return originalList
              } else{
                  return filteredList;
              }*/

              return filteredList;
            },
            // rowsTotals: function(){
            //     var dataSet = this.filteredList;
            //     var headers = this.header.list;
            //     var totalsObj = {};
            //
            //     for (var iDataSet = 0; iDataSet < dataSet.length; iDataSet++) {
            //         //totalsObj.name = '';
            //         for (var header in headers) {
            //             if(header != 'name'){
            //                 if(typeof totalsObj[header] == "undefined"){
            //                     totalsObj[header] = Number(dataSet[iDataSet][header]);
            //                 } else {
            //                     totalsObj[header] += Number(dataSet[iDataSet][header]);
            //                 }
            //             }
            //         }
            //
            //     }
            //
            //     return [totalsObj];
            // },
            graphData: function(){
                let labels = [];
                let invoicedData = [];
                let paidData = [];
                let inDueData = [];

                for (let sale of this.allSales) {
                    const month =  moment(sale.departureDate).format('MMM');
                    const status = sale.bookingAgentPaymentStatus;
                    if (labels.indexOf(month) === -1){
                        labels.push(month);
                        if (status === 0) {
                          inDueData.push(sale.totalGrossprice);
                        } else if (status === 1) {
                          invoicedData.push(sale.totalGrossprice);
                        } else if (status === 2) {
                          paidData.push(sale.totalGrossprice);
                        }

                    } else {
                        const index = labels.indexOf(month);
                        if (status === 0) {
                          inDueData[index] += sale.totalGrossprice;
                        } else if (status === 1) {
                          invoicedData[index] += sale.totalGrossprice;
                        } else if (status === 2) {
                          paidData[index] += sale.totalGrossprice;
                        }
                    }
                }

                labels.reverse();
                invoicedData.reverse();
                paidData.reverse();
                inDueData.reverse();

                var chartData = {
                    labels: labels,
                    datasets: [
                      {
                        data: inDueData,
                        label: 'In due',
                        backgroundColor: '#00a9f0',
                        hoverBackgroundColor: '#8ca0b3'
                      },
                      {
                        data: paidData,
                        label: 'Paid',
                        backgroundColor: '#35d235',
                        hoverBackgroundColor: '#8ca0b3'
                      },
                      {
                        data: invoicedData,
                        label: 'Invoiced',
                        backgroundColor: '#545454',
                        hoverBackgroundColor: '#8ca0b3'
                      },
                    ]
                };

                return chartData;
            }
        },
        methods:{
            ...mapActions([
              'downloadSales',
              'downloadAllSales',
              'downloadSalesExport',
              'refreshAccountData'
            ]),
            async loadSales(start, end) {
                return this.downloadSales({
                    supplierId: this.account.supplierId,
                    agentId: this.selectedAgentsOption.value,
                    productId: this.selectedProductsOption.value,
                    statusId: this.selectedStatusOption.value,
                    dateFrom: start,
                    dateTo: end,
                    page: this.pagination.currentPage,
                    pageSize: 20
                })
            },

            async loadAllSales(start, end) {
              return this.downloadAllSales({
                supplierId: this.account.supplierId,
                dateFrom: start,
                dateTo: end
              })
            },

            toggleShowGraph: function() {
              this.showGraph = !this.showGraph;
              if(this.showGraph){
                this.showCartMessage = 'Hide Cart';
              } else {
                this.showCartMessage = 'Show Cart';
              }
            },

            changeTimeOption: function(timeOption){
                this.showDatePickers = false;
                switch (timeOption.value) {

                    case 'last-12-months':
                        this.dateFrom = moment().subtract(12, 'months').toDate();
                        this.dateTo = moment().toDate();
                        break;

                    case 'last-3-months':
                        this.dateFrom = moment().subtract(3, 'months').toDate();
                        this.dateTo = moment().toDate();
                        break;

                    case 'this-month':
                        this.dateFrom = moment().startOf('month').toDate();
                        this.dateTo = moment().endOf('month').toDate();
                        break;

                    case 'this-week':
                        this.dateFrom = moment().startOf('week').toDate();
                        this.dateTo = moment().endOf('week').toDate();
                        break;

                    case 'today':
                        this.dateFrom = moment().startOf('day').toDate();
                        this.dateTo = moment().endOf('day').toDate();
                        break;

                    case 'custom':
                        this.showDatePickers = true;
                        break;

                    default:

                }

                this.updateSales(true);
            },

            changeAgentsOption: function(agentOption) {
                this.selectedAgentsOption = agentOption;
                this.updateSales();
            },

            changeProductsOption: function(productsOption) {
                this.selectedProductsOption = productsOption;
                this.updateSales();
            },

            changeStatusOption: function(statusOption) {
              this.selectedStatusOption = statusOption;
              this.updateSales();
            },

            setCustomDateFrom: function(date) {
              this.dateFrom = moment(date).toDate();
              this.updateSales(true);
            },
            setCustomDateTo: function(date) {
              this.dateTo = moment(date).toDate();
              this.updateSales(true);
            },
            toggleColumnOptions: function() {
                this.showColumnOptions = !this.showColumnOptions;
            },
            toggleExportOptions: function() {
                this.showExportOptions = !this.showExportOptions;
            },
            pageChanged: function(){
              this.updateSales();
            },
            exportSales() {
              this.downloadSalesExport({
                  supplierId: this.account.supplierId,
                  agentId: this.selectedAgentsOption.value,
                  productId: this.selectedProductsOption.value,
                  statusId: this.selectedStatusOption.value,
                  dateFrom: this.dateFrom,
                  dateTo: this.dateTo,
              }).then((response) => {
                  window.URL = window.URL || window.webkitURL;
                  const headers = response.headers;
                  const blob = new Blob([response.data],{type:headers['content-type']});
                  const link = document.createElement('a');
                  document.body.appendChild(link);
                  link.href = window.URL.createObjectURL(blob);
                  link.download = moment(this.dateFrom).format('YYYY-MM-DD') + '_' + moment(this.dateTo).format('YYYY-MM-DD') + '_report';
                  link.click();
              });
            },
            updateSales: function(updateFilters) {
                // this.refreshAccountData().then((data) => {
                    this.loadSales(this.dateFrom, this.dateTo).then((data) => {
                        if (data.data) {
                            this.rows = data.data.result;
                            this.rowsLoaded = true;
                            this.pageInfo = data.data.pageInfo;
                        }
                        this.loadAllSales(this.dateFrom, this.dateTo).then((data) => {
                            if (data.data) {
                                this.allSales = data.data;
                            } else {
                                this.allSales = this.rows
                            }
                            if (updateFilters) {
                                this.updateFilters();
                            }
                        });
                    });
                // });
            },
            updateFilters: function () {
                this.agentsOptions = [
                    {
                        label: 'All Agents',
                        value: undefined
                    }
                ];

                this.productsOptions = [
                    {
                        label: 'All Products',
                        value: undefined
                    }
                ];
                for (const sale of this.allSales) {
                    if (sale.agentName && (sale.agentId || sale.agentId === 0)) {
                      const obj = {
                          label: sale.agentName,
                          value: sale.agentId
                      };
                      if (this.agentsOptions.filter(e => e.value === obj.value).length <= 0) {
                          this.agentsOptions.push(obj);
                      }
                    }

                    if (sale.productId && sale.productName) {
                        const obj = {
                          label: sale.productName,
                          value: sale.productId
                        };
                        if (this.productsOptions.filter(e => e.value === obj.value).length <= 0) {
                          this.productsOptions.push(obj);
                        }
                    }
                }
            }
        },
        components:{
            vSelect: extendedVSelect,
            List,
            VueDatepicker,
            graph,
            Export,
            Navigator,
            DateRange
        }
    }
</script>

<style scoped lang="scss">
    .scroll-y{
      height: 94vh;
      overflow-y: auto;
    }


</style>
<style lang="scss">
    @import '../../../assets/scss/_variables.scss';

    .dateToCalendar .vdp-datepicker__calendar{
        right: 0;
    }



    //report select home made
    .clickToOpen{
      position: relative;
      .selectDrawer{

        &.left{
          right: 0;
        }

        width: auto;
        background-color: $lightest;
        top: 100%;
        position: absolute;
        z-index: 1;
        box-shadow: 0 2px 6px 0 $dark;

        li{
          white-space: nowrap;
        }
      }
    }
</style>



// WEBPACK FOOTER //
// createReport.vue?665b1f6a